import React from 'react'
import {Link} from "react-router-dom"

function Sec03BT() {
    return (
        <div>
                <section className="S3-Bagtypes dflex full-center">
                    <div className="Bagtypes dflex ai-center w74">
                        <Link to="/all_instruments">All Instruments</Link>
                        <Link to="/guitars">Guitars</Link>
                        <Link to="/pianos">Pianos</Link>
                        <Link to="/violins">Violins</Link>
                        <Link to="/drums">Drums</Link>
                        <Link to="/forkids">For kids</Link>
                    </div>
                </section>

        </div>
    )
}

export default Sec03BT
